import { render, staticRenderFns } from "./CardPage.vue?vue&type=template&id=392b0d57&scoped=true"
import script from "./CardPage.vue?vue&type=script&lang=js"
export * from "./CardPage.vue?vue&type=script&lang=js"
import style0 from "./CardPage.vue?vue&type=style&index=0&id=392b0d57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392b0d57",
  null
  
)

export default component.exports